import {Mechanics} from '../../../types/Mechanics';
import {hasNestedData} from './hasNestedData';

type BreakPad = NonNullable<Mechanics>['brake']['brakePad'];

export function hasBrakePadInfo(brakePad: BreakPad, showEmptyFields: boolean) {
  if (showEmptyFields) {
    return true;
  }
  return hasNestedData(brakePad);
}
